/* global axios */
import ApiClient from './ApiClient';

class IssueClustersAPI extends ApiClient {
  constructor() {
    super('issue_clusters', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  merge(id, sourceIds) {
    return axios.post(`${this.url}/${id}/merge`, { source_ids: sourceIds });
  }

  split(id, ticketIds) {
    return axios.post(`${this.url}/${id}/split`, { ticket_ids: ticketIds });
  }
}

export default new IssueClustersAPI();
